import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_EXAM_TYPE_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_EXAM_TYPE_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {ExamTypeModel} from '../exam-configuration/useGetExamType';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamType = ({onSuccess, onError}: Input = {}) => {
  const getNonNationalExamType = async () => {
    const res = await axiosClient.get<ExamTypeModel[]>(GET_NON_NATIONAL_EXAM_TYPE_URL);
    return res.data;
  };

  return useCustomQuery(GET_NON_NATIONAL_EXAM_TYPE_QUERY_KEY, getNonNationalExamType, {
    onSuccess,
    onError,
  });
};
